<template>
    <form class="mail-module" action="" @submit.prevent="formSubmit()">
        <div class="arrow"><span class="icon-arrow-right"></span></div>
        <p>Dites-nous qui vous êtes...</p>
        <div class="field-wrapper">
            <input type="email" name="email" v-model="email" placeholder="Saisissez votre email" required>
            <button type="submit" class="btn bleu barre link"><span>Suivant</span></button>
        </div>
    </form>
</template>

<script>
    import $ from "jquery";
    import barba from "@barba/core"

    export default {
        props: {
            url: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                email: null
            };
        },
        methods: {
            formSubmit() {
                barba.go(this.url + "?email=" + encodeURIComponent(this.email))
            }
        },
        mounted() {
        },
        destroyed() {
        }
    };
</script>
